import * as actions from '../actions/reset_password';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
var initialState = {
  isProcessing: false,
  error: null
};
export default reducerWithInitialState(initialState).case(actions.requestResetPassword, function () {
  return {
    isProcessing: true,
    error: null
  };
}).case(actions.successResetPassword, function () {
  return {
    isProcessing: false,
    error: null
  };
}).case(actions.failureResetPassword, function (_, payload) {
  return {
    isProcessing: false,
    error: payload
  };
});